<div class="flex flex-col gap-6 w-full p-4">
    <h2 class="text-xl font-semibold text-center mt-4">{{ translateServ.dictionary['STEP_MOVE_C6_TITLE'] }}</h2>
    <p class="text-center text-gray-400">{{ translateServ.dictionary['STEP_MOVE_C6_TEXT'] }}</p>

    <p-toast></p-toast>

    <!-- Code Option Radio Buttons -->
    <div class="flex flex-wrap justify-center gap-4 mb-4" *ngIf = "!isDialogMode">
        <div class="flex items-center">
            <p-radioButton
                name="code6111Option"
                [value]="true"
                [(ngModel)]="selectedCodeOption"
                (ngModelChange)="onCodeOptionChange($event)"
                inputId="defaultCode6111"
            ></p-radioButton>
            <label for="defaultCode6111" class="ml-2">{{ translateServ.dictionary['STEP_MOVE_C6_OP_DEF_TEXT'] }}</label>
        </div>
        <div class="flex items-center">
            <p-radioButton
                name="code6111Option"
                [value]="false"
                [(ngModel)]="selectedCodeOption"
                (ngModelChange)="onCodeOptionChange($event)"
                inputId="modifyCode6111"
            ></p-radioButton>
            <label for="modifyCode6111" class="ml-2">{{ translateServ.dictionary['STEP_MOVE_C6_OP_MOD_TEXT'] }}</label>
        </div>
    </div>

    <!-- Custom Move Code 6111 Table (conditionally enabled/disabled) -->
    <div class="card p-card-modern p-datatable-form" [ngClass]="{'opacity-50 pointer-events-none': selectedCodeOption}">
        <p-table [value]="moveCode6111" [tableStyle]="{'min-width': '50rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_EXP_CODE'] }}</th>
                    <th style="width: 25%;">{{ translateServ.dictionary['STEP_TAB_TIT_CATEGORY'] }}</th>
                    <th style="width: 10%;">Move Code</th> 
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] }}</th>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] }}</th>
                    <th style="width: 25%;">{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] }}</th>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT'] }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-codeEntry>
                <tr>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="codeEntry.expenseCode"
                            (ngModelChange)="emitChanges()"
                            [maxlength]="EXPENSE_CODE_MAX_LENGTH"
                            class="w-full"
                            placeholder="{{ translateServ.dictionary['STEP_MOVE_C6_TYPE_HELPER'] }}"
                            [disabled]="selectedCodeOption"
                        />
                    </td>
                    <td>
                        <p-autoComplete
                            [suggestions]="filteredCategories"
                            (completeMethod)="searchCategories($event)"
                            [(ngModel)]="codeEntry.category"
                            (ngModelChange)="onNewCategoryChange(codeEntry)"
                            [forceSelection]="false"
                            [dropdown]="true"
                            placeholder="{{ translateServ.dictionary['PLACEHOLDER_CATEGORY'] }}"
                            optionLabel="label"
                            [dataKey]="'value'"
                            [showEmptyMessage]="false"
                            styleClass="w-full"
                            inputStyleClass="p-inputtext-sm"
                            [completeOnFocus]="true"
                            [appendTo]="'body'"
                        ></p-autoComplete>
                    </td>
                    <td>
                        <p-autoComplete
                            [(ngModel)]="codeEntry.moveCode"
                            (ngModelChange)="onNewMoveCodeChange(codeEntry)"
                            [suggestions]="filteredMoveCodes"
                            (completeMethod)="filterMoveCodes($event)"
                            [forceSelection]="false"
                            [dropdown]="true"
                            placeholder="{{ translateServ.dictionary['PLACEHOLDER_MOVE_CODE'] }}"
                            optionLabel="label"
                            [dataKey]="'value'"
                            [showEmptyMessage]="false"
                            styleClass="p-inputtext-sm w-full"
                            inputStyleClass="p-inputtext-sm"
                            [completeOnFocus]="true"
                            [appendTo]="'body'"
                        ></p-autoComplete>
                    </td>
                    <td>
                        <p-tag
                            [value]="codeEntry.isActive === 1 ? 'Active' : 'Inactive'"
                            (click)="toggleIsActive(codeEntry)"
                            [severity]="codeEntry.isActive === 1 ? 'success' : 'danger'">
                        </p-tag>
                    </td>
                    <td>
                        <p-tag
                            [value]="codeEntry.isApproved === 1 ? 'Approved' : 'Not Approved'"
                            (click)="toggleIsApproved(codeEntry)"
                            [severity]="codeEntry.isApproved === 1 ? 'success' : 'warning'">
                        </p-tag>
                    </td>
                    <td>
                        <textarea
                            pInputTextarea
                            [(ngModel)]="codeEntry.description"
                            (ngModelChange)="emitChanges()"
                            [rows]="1"
                            [maxlength]="DESCRIPTION_MAX_LENGTH"
                            class="w-full"
                            placeholder="{{translateServ.dictionary['MAINT_IN_TIT_DESC']}}"
                            [disabled]="selectedCodeOption"
                        ></textarea>
                        <div class="text-right text-xs text-gray-500 mt-1">
                            {{ getRemainingChars(codeEntry.description) }} {{ translateServ.dictionary['CHARS_REMAINING'] }}
                        </div>
                    </td>
                    <td>
                        <div class="flex gap-2">
                            <p-button *ngIf="isCreate"
                                icon="pi pi-trash"
                                severity="danger"
                                styleClass="p-button-text p-button-sm"
                                (onClick)="removeEntry(codeEntry)"
                                [disabled]="selectedCodeOption">
                            </p-button>

                            <button
                                    *ngIf="!isCreate"
                                    pButton
                                    type="button"
                                    icon="pi pi-check"
                                    class="p-button-rounded p-button-text p-button-sm p-button-info"
                                    (click)="applyRowChanges(codeEntry)"
                                    [label]="translateServ.dictionary['APPLY_CHANGES'] || 'Apply Changes'">
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" *ngIf = "isCreate">
                <tr>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.expenseCode"
                            [maxlength]="EXPENSE_CODE_MAX_LENGTH"
                            class="w-full"
                            placeholder="{{ translateServ.dictionary['STEP_MOVE_C6_TYPE_HELPER'] }}"
                            [disabled]="selectedCodeOption"
                        />
                    </td>
                    <td>
                        <p-autoComplete
                            [suggestions]="filteredCategories"
                            (completeMethod)="searchCategories($event)"
                            [(ngModel)]="newEntry.category"
                            (ngModelChange)="onNewCategoryChange(newEntry)"
                            [forceSelection]="false"
                            [dropdown]="true"
                            placeholder="{{ translateServ.dictionary['PLACEHOLDER_CATEGORY'] }}"
                            optionLabel="label"
                            [dataKey]="'value'"
                            [showEmptyMessage]="false"
                            styleClass="w-full"
                            inputStyleClass="p-inputtext-sm"
                            [completeOnFocus]="true"
                            [appendTo]="'body'"
                        ></p-autoComplete>
                    </td>
                    <td>
                        <p-autoComplete
                            [(ngModel)]="newEntry.moveCode"
                            (ngModelChange)="onNewMoveCodeChange(newEntry)"
                            [suggestions]="filteredMoveCodes"
                            (completeMethod)="filterMoveCodes($event)"
                            [forceSelection]="false"
                            [dropdown]="true"
                            placeholder="{{ translateServ.dictionary['PLACEHOLDER_MOVE_CODE'] }}"
                            optionLabel="label"
                            [dataKey]="'value'"
                            [showEmptyMessage]="false"
                            styleClass="p-inputtext-sm w-full"
                            inputStyleClass="p-inputtext-sm"
                            [completeOnFocus]="true"
                            [appendTo]="'body'"
                        ></p-autoComplete>
                    </td>
                    <td>
                        <p-tag
                            [value]="newEntry.isActive === 1 ? 'Active' : 'Inactive'"
                            (click)="toggleIsActive(newEntry)"
                            [severity]="newEntry.isActive === 1 ? 'success' : 'danger'">
                        </p-tag>
                    </td>
                    <td>
                        <p-tag
                            [value]="newEntry.isApproved === 1 ? 'Approved' : 'Not Approved'"
                            (click)="toggleIsApproved(newEntry)"
                            [severity]="newEntry.isApproved === 1 ? 'success' : 'warning'">
                        </p-tag>
                    </td>
                    <td>
                        <textarea
                            pInputTextarea
                            [(ngModel)]="newEntry.description"
                            [rows]="1"
                            [maxlength]="DESCRIPTION_MAX_LENGTH"
                            class="w-full"
                            placeholder="{{translateServ.dictionary['MAINT_IN_TIT_DESC']}}"
                            [disabled]="selectedCodeOption"
                        ></textarea>
                        <div class="text-right text-xs text-gray-500 mt-1">
                            {{ getRemainingChars(newEntry.description) }} {{ translateServ.dictionary['CHARS_REMAINING'] }}
                        </div>
                    </td>
                    <td>
                        <p-button
                            label="{{translateServ.dictionary['ADD']}}"
                            icon="pi pi-plus"
                            severity="success"
                            styleClass="p-button-text p-button-sm"
                            (onClick)="addEntry()"
                            [disabled]="selectedCodeOption">
                        </p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4" class="text-center text-gray-500">
                        <ng-container *ngIf="selectedCodeOption; else noCustomCodes">
                            {{translateServ.dictionary['STEP_MOVE_C6_MSG']}}
                        </ng-container>
                        <ng-template #noCustomCodes>
                            {{translateServ.dictionary['STEP_MOVE_C6_MSG_NO']}}
                        </ng-template>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Navigation Buttons -->
    <div class="flex justify-between pt-6">
        <ng-container *ngIf="!isDialogMode">
            <p-button
                [label]="translateServ.dictionary['BACK']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
                [iconPos]="dirServ.isRtl() ? 'right' : 'left'"
                severity="secondary"
                (onClick)="goToPreviousStep()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['NEXT']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
                [iconPos]="dirServ.isRtl() ? 'left' : 'right'"
                (onClick)="validateAndProceed()">
            </p-button>
        </ng-container>
        <ng-container *ngIf="isDialogMode">
            <p-button
                [label]="translateServ.dictionary['CANCEL'] || 'Cancel'"
                [icon]="'pi pi-times'"
                severity="secondary"
                (onClick)="closeDialog()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['SAVE'] || 'Save'"
                [icon]="'pi pi-save'"
                (onClick)="saveAndSubmit()"
                [disabled]="moveCode6111.length === 0">
            </p-button>
        </ng-container>
    </div>
</div>
